import React from 'react';
import { bool, func, string, arrayOf, shape, object } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import './TimePicker.css';

import { propTypes } from '../../util/types';
import {
  FieldTimeRangePicker,
  Form,
  PrimaryButton,
} from '../../components';
import css from './EditListingSchedulesForm.css';

const EditListingSchedulesForm = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={fieldRenderProps => {
      const {
        className,
        disabled,
        handleSubmit,
        invalid,
        intl,
        pristine,
        ready,
        saveActionMsg,
        updated,
        updateError,
        updateInProgress,
        values,
      } = fieldRenderProps;
      const errorMessage = updateError ? (
        <p className={css.error}>
            <FormattedMessage id='EditListingSchedulesForm.updateFailed' />
        </p>
      ) : null;

      const schedulesInfoText = intl.formatMessage({ id: 'EditListingSchedulesForm.schedulesInfo' });
      const morningLabel = intl.formatMessage({ id: 'EditListingSchedulesForm.morningLabel' });
      const afternoonLabel = intl.formatMessage({ id: 'EditListingSchedulesForm.afternoonLabel' });
      const eveningLabel = intl.formatMessage({ id: 'EditListingSchedulesForm.eveningLabel' });

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress || ready;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          <p className={css.info}>{schedulesInfoText}</p>
          <FieldTimeRangePicker
            className={css.timeRangePicker}
            idStart="morningSlotStart"
            nameStart="morningSlotStart"
            idEnd="morningSlotEnd"
            nameEnd="morningSlotEnd"
            label={morningLabel}
            minuteStep={15}
            maxHour={values.afternoonSlotStart.hour}
            minHourBetween={2}
            currentValues={values}
          />
          <FieldTimeRangePicker
            className={css.timeRangePicker}
            idStart="afternoonSlotStart"
            nameStart="afternoonSlotStart"
            idEnd="afternoonSlotEnd"
            nameEnd="afternoonSlotEnd"
            label={afternoonLabel}
            minuteStep={15}
            minHour={values.morningSlotEnd.hour}
            maxHour={values.eveningSlotStart.hour}
            minHourBetween={2}
            currentValues={values}
          />
          <FieldTimeRangePicker
            className={classNames(css.timeRangePicker, css.lastField)}
            idStart="eveningSlotStart"
            nameStart="eveningSlotStart"
            idEnd="eveningSlotEnd"
            nameEnd="eveningSlotEnd"
            label={eveningLabel}
            minuteStep={15}
            minHour={values.afternoonSlotEnd.hour}
            maxHour={24}
            minHourBetween={2}
            currentValues={values}
          />

          <div className={css.buttonContainer}>
            <PrimaryButton
              className={css.submitButton}
              type='submit'
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </PrimaryButton>
          </div>
        </Form>
      );
    }}
  />
);

EditListingSchedulesForm.defaultProps = {
  className: null,
  updateError: null,
  initialValues: {},
};

EditListingSchedulesForm.propTypes = {
  className: string,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  updated: bool.isRequired,
  updateError: propTypes.error,
  updateInProgress: bool.isRequired,
  initialValues: object,

  // from injectIntl
  intl: intlShape.isRequired,
};

export default compose(injectIntl)(EditListingSchedulesForm);



// WEBPACK FOOTER //
// ./src/forms/EditListingSchedulesForm/EditListingSchedulesForm.js